// ─── Status badge ─────────────────────────────────────────────────────────────
export const StatusBadge = ({ status, mode }) => {
  const colors = {
    "In Production": { bg: "#EFF8FF", text: "#FF9900" },
    "Ready For Dispatch": { bg: "#ECFDF3", text: "#027A48" },
    Dispatched: { bg: "#ECFDF3", text: "#027A48" },
    "New Voucher": { bg: "#FFF6ED", text: "#4164E3" },
    Voucher: { bg: "#FFF6ED", text: "#C4320A" },
    Cancelled: { bg: "#FFF1F3", text: "#C01048" },
    Completed: { bg: "#ECFDF3", text: "#027A48" },
  };
  const c = colors[status] || { bg: "#F2F4F7", text: "#344054" };
  return (
    <span
      style={{
        backgroundColor: mode ? "transparent" : c.bg,
        color: mode ? c.text : c.text,
        border: `1px solid ${c.text}33`,
        borderRadius: 20,
        padding: "2px 8px",
        fontSize: 11,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      {status}
    </span>
  );
};
